import { Alert, Table } from "flowbite-react";
import NoOcurrence from "../common/query/NoOcurrence";
import TitleStripe from "../common/TitleStripe";
import SurveySheet from "./SurveySheet";
import { formatToReal, getImageScoreSale } from "../../utils/utils";
import { FaCar } from "react-icons/fa";
import PdfViewer from "../common/query/PdfViewer";
import { MdBlock, MdInfoOutline } from "react-icons/md";
import { FiAlertOctagon } from "react-icons/fi";
import moment from "moment";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

const SurveyQuery = ({ surveyReceived }) => {
  return (
    <>
      {surveyReceived?.SurveyVehicle?.vehicleQuery && (
        <>
          <SurveySheet survey={surveyReceived}>
            <div className="px-5 mt-5">
              <div>
                <TitleStripe>Quadro de avisos</TitleStripe>
                <div className="container-alerts three-columns mt-3">
                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                    ?.leilaoConjugado &&
                    surveyReceived?.SurveyVehicle?.vehicleQuery?.leilaoConjugado
                      ?.statusRetorno == 1 && (
                      <>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery?.leilaoConjugado?.ocorrencias?.some(
                          (leilao) => leilao?.ocorrencias?.length > 0
                        ) ? (
                          <Alert
                            color="failure"
                            withBorderAccent
                            className="flex justify-center items-center flex-col"
                          >
                            <div className="text-center">
                              Alerta de Leilão II
                            </div>
                            <div className="text-center font-semibold">Sim</div>
                          </Alert>
                        ) : (
                          <Alert
                            color="success"
                            withBorderAccent
                            className="flex justify-center items-center flex-col"
                          >
                            <div className="text-center">
                              Alerta de Leilão II
                            </div>
                            <div className="text-center font-semibold">
                              Nada consta
                            </div>
                          </Alert>
                        )}
                      </>
                    )}

                  {surveyReceived?.SurveyVehicle?.vehicleQuery?.leilaoSimples &&
                    surveyReceived?.SurveyVehicle?.vehicleQuery?.leilaoSimples
                      ?.statusRetorno == 1 && (
                      <>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery?.leilaoSimples?.ocorrencias?.some(
                          (leilao) => leilao?.ocorrencias?.length > 0
                        ) ? (
                          <Alert
                            color="failure"
                            withBorderAccent
                            className="flex justify-center items-center flex-col"
                          >
                            <div className="text-center">Alerta de Leilão</div>
                            <div className="text-center font-semibold">Sim</div>
                          </Alert>
                        ) : (
                          <Alert
                            color="success"
                            withBorderAccent
                            className="flex justify-center items-center flex-col"
                          >
                            <div className="text-center">Alerta de Leilão</div>
                            <div className="text-center font-semibold">
                              Nada consta
                            </div>
                          </Alert>
                        )}
                      </>
                    )}

                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                    ?.historicoRouboEFurto &&
                    surveyReceived?.SurveyVehicle?.vehicleQuery
                      ?.historicoRouboEFurto?.statusRetorno == 1 && (
                      <>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.historicoRouboEFurto?.temHistoricoRouboEFurto ==
                        "0" ? (
                          <Alert
                            color="success"
                            withBorderAccent
                            className="flex justify-center items-center flex-col"
                          >
                            <div className="text-center">
                              Histórico roubo e furto
                            </div>
                            <div className="text-center font-semibold">
                              Nada consta
                            </div>
                          </Alert>
                        ) : (
                          <Alert
                            color="failure"
                            withBorderAccent
                            className="flex justify-center items-center flex-col"
                          >
                            <div className="text-center">
                              Histórico roubo e furto
                            </div>
                            <div className="text-center font-semibold">Sim</div>
                          </Alert>
                        )}
                      </>
                    )}

                  {/* {surveyReceived?.SurveyVehicle?.vehicleQuery
                    ?.indicioSinistro3 &&
                    surveyReceived?.SurveyVehicle?.vehicleQuery
                      ?.indicioSinistro3?.statusRetorno == 1 && (
                      <>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.indicioSinistro3?.temIndicio == "0" ? (
                          <Alert
                            color="success"
                            withBorderAccent
                            className="flex justify-center items-center flex-col"
                          >
                            <div className="text-center">
                              Indício de sinistro III
                            </div>
                            <div className="text-center font-semibold">
                              Nada consta
                            </div>
                          </Alert>
                        ) : (
                          <Alert
                            color="failure"
                            withBorderAccent
                            className="flex justify-center items-center flex-col"
                          >
                            <div className="text-center">
                              Indício de sinistro III
                            </div>
                            <div className="text-center font-semibold">Sim</div>
                          </Alert>
                        )}
                      </>
                    )} */}

                  {surveyReceived?.SurveyVehicle?.vehicleQuery?.binEstadual &&
                    surveyReceived?.SurveyVehicle?.vehicleQuery?.binEstadual
                      ?.statusRetorno == 1 && (
                      <>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.restricoes?.ipva?.existePendencia ==
                        "0" ? (
                          <Alert
                            color="success"
                            withBorderAccent
                            className="flex justify-center items-center flex-col"
                          >
                            <div className="text-center">IPVA</div>
                            <div className="text-center font-semibold">
                              Nada consta
                            </div>
                          </Alert>
                        ) : (
                          <Alert
                            color="failure"
                            withBorderAccent
                            className="flex justify-center items-center flex-col"
                          >
                            <div className="text-center">IPVA</div>
                            <div className="text-center font-semibold">
                              R${" "}
                              {
                                surveyReceived?.SurveyVehicle?.vehicleQuery
                                  ?.binEstadual?.restricoes?.ipva
                                  ?.valorPendencia
                              }
                            </div>
                          </Alert>
                        )}
                      </>
                    )}

                  {surveyReceived?.SurveyVehicle?.vehicleQuery?.binEstadual &&
                    surveyReceived?.SurveyVehicle?.vehicleQuery?.binEstadual
                      ?.statusRetorno == 1 && (
                      <>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.restricoes?.dpvat?.existePendencia ==
                        "0" ? (
                          <Alert
                            color="success"
                            withBorderAccent
                            className="flex justify-center items-center flex-col"
                          >
                            <div className="text-center">DPVAT</div>
                            <div className="text-center font-semibold">
                              Nada consta
                            </div>
                          </Alert>
                        ) : (
                          <Alert
                            color="failure"
                            withBorderAccent
                            className="flex justify-center items-center flex-col"
                          >
                            <div className="text-center">DPVAT</div>
                            <div className="text-center font-semibold">
                              R${" "}
                              {
                                surveyReceived?.SurveyVehicle?.vehicleQuery
                                  ?.binEstadual?.restricoes?.dpvat
                                  ?.valorPendencia
                              }
                            </div>
                          </Alert>
                        )}
                      </>
                    )}

                  {surveyReceived?.SurveyVehicle?.vehicleQuery?.binEstadual &&
                    surveyReceived?.SurveyVehicle?.vehicleQuery?.binEstadual
                      ?.statusRetorno == 1 && (
                      <>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.restricoes?.multas?.existePendencia ==
                        "0" ? (
                          <Alert
                            color="success"
                            withBorderAccent
                            className="flex justify-center items-center flex-col"
                          >
                            <div className="text-center">Multas</div>
                            <div className="text-center font-semibold">
                              Nada consta
                            </div>
                          </Alert>
                        ) : (
                          <Alert
                            color="failure"
                            withBorderAccent
                            className="flex justify-center items-center flex-col"
                          >
                            <div className="text-center">Multas</div>
                            <div className="text-center font-semibold">
                              R${" "}
                              {
                                surveyReceived?.SurveyVehicle?.vehicleQuery
                                  ?.binEstadual?.restricoes?.multas
                                  ?.valorPendencia
                              }
                            </div>
                          </Alert>
                        )}
                      </>
                    )}

                  {surveyReceived?.SurveyVehicle?.vehicleQuery?.binEstadual &&
                    surveyReceived?.SurveyVehicle?.vehicleQuery?.binEstadual
                      ?.statusRetorno == 1 && (
                      <>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.restricoes?.licenciamento
                          ?.existePendencia == "0" ? (
                          <Alert
                            color="success"
                            withBorderAccent
                            className="flex justify-center items-center flex-col"
                          >
                            <div className="text-center">Licenciamento</div>
                            <div className="text-center font-semibold">
                              Nada consta
                            </div>
                          </Alert>
                        ) : (
                          <Alert
                            color="failure"
                            withBorderAccent
                            className="flex justify-center items-center flex-col"
                          >
                            <div className="text-center">Licenciamento</div>
                            <div className="text-center font-semibold">
                              R${" "}
                              {
                                surveyReceived?.SurveyVehicle?.vehicleQuery
                                  ?.binEstadual?.restricoes?.licenciamento
                                  ?.valorPendencia
                              }
                            </div>
                          </Alert>
                        )}
                      </>
                    )}

                  {/* {surveyReceived?.SurveyVehicle?.vehicleQuery
                    ?.indicioSinistro3 &&
                    surveyReceived?.SurveyVehicle?.vehicleQuery
                      ?.indicioSinistro3?.statusRetorno == 1 && (
                      <>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.indicioSinistro3?.temIndicio == "0" ? (
                          <Alert
                            color="success"
                            withBorderAccent
                            className="flex justify-center items-center flex-col"
                          >
                            <div className="text-center">
                              Indício de sinistro III
                            </div>
                            <div className="text-center font-semibold">
                              Nada consta
                            </div>
                          </Alert>
                        ) : (
                          <Alert
                            color="failure"
                            withBorderAccent
                            className="flex justify-center items-center flex-col"
                          >
                            <div className="text-center">
                              Indício de sinistro III
                            </div>
                            <div className="text-center font-semibold">Sim</div>
                          </Alert>
                        )}
                      </>
                    )} */}

                  {surveyReceived?.SurveyVehicle?.vehicleQuery?.binEstadual &&
                    surveyReceived?.SurveyVehicle?.vehicleQuery?.binEstadual
                      ?.statusRetorno == 1 && (
                      <>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.restricoes
                          ?.existeRestricaoRouboFurto == "0" ? (
                          <Alert
                            color="success"
                            withBorderAccent
                            className="flex justify-center items-center flex-col"
                          >
                            <div className="text-center">Roubo e furto</div>
                            <div className="text-center font-semibold">
                              Nada consta
                            </div>
                          </Alert>
                        ) : (
                          <Alert
                            color="failure"
                            withBorderAccent
                            className="flex justify-center items-center flex-col"
                          >
                            <FiAlertOctagon
                              fontSize={30}
                              className="mx-auto mb-1"
                            />
                            <div className="text-center">
                              Restrição roubo e furto
                            </div>
                            <div className="text-center font-semibold">Sim</div>
                          </Alert>
                        )}
                      </>
                    )}
                </div>
              </div>

              {surveyReceived?.SurveyVehicle?.vehicleQuery?.binNacional &&
                surveyReceived?.SurveyVehicle?.vehicleQuery?.binNacional
                  ?.statusRetorno == 1 && (
                  <div className="mt-5">
                    <div className="flex flex-col gap-10">
                      {surveyReceived?.SurveyVehicle?.vehicleQuery
                        ?.binNacional && (
                        <div className="text-sm flex-1">
                          <div className="title-vehicle mb-3 flex gap-2 items-center">
                            <div>Informações do veículo - Nacional</div>
                            <img
                              className="w-5"
                              src="/assets/base_nacional.png"
                            />
                          </div>
                          {surveyReceived?.SurveyVehicle?.vehicleQuery
                            ?.binNacional?.statusRetorno == 1 ? (
                            <>
                              <div className="p-2 rounded bg-gray-100 grid grid-cols-3 gap-x-3 gap-y-1 text-xs">
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Marca/Modelo:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.marcaModelo || "Sem info."}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Ano Fabr./Modelo:{" "}
                                  </span>
                                  {`${surveyReceived?.SurveyVehicle?.vehicleQuery?.binNacional?.anoFabricacao}/${surveyReceived?.SurveyVehicle?.vehicleQuery?.binNacional?.anoModelo}` ||
                                    "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Tempo de circulação:{" "}
                                  </span>
                                  {`${
                                    moment().format("YYYY") -
                                    +surveyReceived?.SurveyVehicle?.vehicleQuery
                                      ?.binNacional?.anoFabricacao
                                  } anos` || "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Categoria:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.categoriaVeiculo ||
                                    "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Tipo de veículo:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.tipoVeiculo ||
                                    "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    RENAVAM:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.renavam || "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Chassi:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.chassi || "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Situação:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.situacao || "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Cilindrada:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.cilindrada ||
                                    "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">CMT: </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.cmt || "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Combustível:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.combustivel ||
                                    "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">Cor: </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.corVeiculo ||
                                    "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Emplacamento:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.dataEmplacamento ||
                                    "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Espécie:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.especieVeiculo ||
                                    "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Município:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.municipio || "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">UF: </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.uf || "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Nº Carroceria:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.numeroCarroceria ||
                                    "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">Nº DI: </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.numeroDI || "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Qtd. Eixos:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.numeroEixos ||
                                    "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Nº Motor:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.numeroMotor ||
                                    "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">PBT: </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.PBT || "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Potência:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.potenciaVeiculo ||
                                    "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Procedência:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.procedencia ||
                                    "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Qtd. Passageiros:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.quantidadePassageiros ||
                                    "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Situação do chassi:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.situacaoChassi ||
                                    "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Tipo de Carroceria:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.tipoCarroceria ||
                                    "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Tipo Doc. Faturado:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.tipoDocumentoFaturado ||
                                    "Não informado"}
                                </div>

                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Montagem:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.tipoMontagem ||
                                    "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Nº Faturado:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional
                                    ?.numeroIdentificacaoFaturado ||
                                    "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    UF Faturamento:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.ufFaturamento ||
                                    "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Data Atualização:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.dataAtualizacao ||
                                    "Não informado"}
                                </div>
                                <div className="mb-2">
                                  <span className="font-semibold">
                                    Data Emissão Último CRV:{" "}
                                  </span>
                                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                                    ?.binNacional?.dataEmissaoUltimoCRV ||
                                    "Não informado"}
                                </div>
                              </div>
                              <div className="mb-2 p-2 rounded bg-gray-100 mt-2 text-sm">
                                <span
                                  className={`font-semibold ${
                                    surveyReceived?.SurveyVehicle?.vehicleQuery
                                      ?.binNacional?.restricoes?.length > 0
                                      ? "text-red-500"
                                      : "text-black"
                                  }`}
                                >
                                  Restrições Gerais
                                </span>
                                {surveyReceived?.SurveyVehicle?.vehicleQuery
                                  ?.binNacional?.restricoes?.length > 0 ? (
                                  <ul className="flex flex-col gap-1 mt-2">
                                    {surveyReceived?.SurveyVehicle?.vehicleQuery?.binNacional?.restricoes?.map(
                                      (restricao, idx) => (
                                        <li key={idx} className="font-semibold">
                                          - {restricao}
                                        </li>
                                      )
                                    )}
                                  </ul>
                                ) : (
                                  <div className="font-semibold text-green-500">
                                    Nada consta
                                  </div>
                                )}
                              </div>
                            </>
                          ) : (
                            <Alert
                              withBorderAccent
                              color="gray"
                              className="mt-4"
                            >
                              Consulta Indisponível no momento
                            </Alert>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
            </div>
          </SurveySheet>

          <SurveySheet survey={surveyReceived}>
            <div className="px-5 mt-10">
              {surveyReceived?.SurveyVehicle?.vehicleQuery?.binEstadual ? (
                <div className="text-sm flex-1">
                  <div className="title-vehicle mb-3">
                    Informações do veículo - Estadual
                  </div>
                  {surveyReceived?.SurveyVehicle?.vehicleQuery?.binEstadual
                    ?.statusRetorno == 1 ? (
                    <div className="p-2 rounded bg-gray-100 grid grid-cols-3 gap-x-3 gap-y-2 text-xs">
                      <div className="mb-3">
                        <span className="font-semibold">Marca/Modelo: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.marcaModelo || "Sem info."}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">
                          Ano Fabr./Modelo:{" "}
                        </span>
                        {`${surveyReceived?.SurveyVehicle?.vehicleQuery?.binEstadual?.anoFabricacao}/${surveyReceived?.SurveyVehicle?.vehicleQuery?.binEstadual?.anoModelo}` ||
                          "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">
                          Tempo de circulação:{" "}
                        </span>
                        {`${
                          moment().format("YYYY") -
                          +surveyReceived?.SurveyVehicle?.vehicleQuery
                            ?.binEstadual?.anoFabricacao
                        } anos` || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">Categoria: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.categoriaVeiculo || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">Tipo de veículo: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.tipoVeiculo || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">RENAVAM: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.renavam || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">Chassi: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.chassi || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">Situação: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.situacao || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">Câmbio: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.caixaCambio || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">
                          Capacidade Carga:{" "}
                        </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.capacidadeCarga || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">Cilindrada: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.cilindrada || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">CMT: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.cmt || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">Combustível: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.combustivel || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">Cor: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.corVeiculo || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">Emplacamento: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.dataEmplacamento || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">Espécie: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.especieVeiculo || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">Município: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.municipio || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">UF: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.uf || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">Nº Carroceria: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.numeroCarroceria || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">Nº DI: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.numeroDI || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">
                          Data registro DI:{" "}
                        </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.dataRegistroDI || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">
                          Nº Eixo Auxiliar:{" "}
                        </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.numeroEixoAuxiliar || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">
                          Nº Eixo Traseiro:{" "}
                        </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.numeroEixoTrazeiro || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">Qtd. Eixos: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.numeroEixos || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">Nº Motor: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.numeroMotor || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">PBT: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.pbt || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">Potência: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.potenciaVeiculo || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">Procedência: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.procedencia || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">
                          Qtd. Passageiros:{" "}
                        </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.quantidadePassageiros ||
                          "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">
                          Situação do chassi:{" "}
                        </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.situacaoChassi || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">
                          Tipo de Carroceria:{" "}
                        </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.tipoCarroceria || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">
                          Tipo Doc. Faturado:{" "}
                        </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.tipoDocumentoFaturado ||
                          "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">
                          Tipo Doc. Importador:{" "}
                        </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.tipoDocumentoImportador ||
                          "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">Nº Importador: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.numeroIdentificacaoImportador ||
                          "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">
                          Tipo Op. Importação:{" "}
                        </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.tipoOperacaoImportacaoVeiculo ||
                          "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">Montagem: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.tipoMontagem || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">Nº Faturado: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.numeroIdentificacaoFaturado ||
                          "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">UF Faturamento: </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.ufFaturamento || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">
                          Data Limite Rest. Tributária:{" "}
                        </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.DATA_LIMITE_RESTRICAO_TRIBUTARIA ||
                          "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">
                          Data Atualização:{" "}
                        </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.dataAtualizacao || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">
                          Código Órgão SRF:{" "}
                        </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.codigoOrgaoSRF || "Não Informado"}
                      </div>
                      <div className="mb-3">
                        <span className="font-semibold">
                          Data Emissão Último CRV:{" "}
                        </span>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.dataEmissaoUltimoCRV ||
                          "Não Informado"}
                      </div>
                    </div>
                  ) : (
                    <Alert withBorderAccent color="gray" className="mt-4">
                      Consulta Indisponível no momento
                    </Alert>
                  )}
                </div>
              ) : (
                <>
                  <TitleStripe>Base estadual</TitleStripe>
                  <Alert withBorderAccent color="gray" className="mt-4">
                    Base Estadual Indisponível no momento
                  </Alert>
                </>
              )}
              {surveyReceived?.SurveyVehicle?.vehicleQuery?.binEstadual &&
                surveyReceived?.SurveyVehicle?.vehicleQuery?.binEstadual
                  ?.statusRetorno == 1 && (
                  <div className="grid grid-cols-3 gap-3 bg-gray-100 p-2 text-xs">
                    <div>
                      <div className="title-vehicle">
                        Proprietário | Estadual
                      </div>
                      <div className="mt-3">
                        <span className="font-semibold">Nome:</span>{" "}
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.proprietario?.nome || "Não informado"}
                      </div>
                      <div className="mt-2">
                        <span className="font-semibold">Documento:</span>{" "}
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.proprietario?.documento ||
                          "Não informado"}
                      </div>
                    </div>

                    <div>
                      <div className="title-vehicle">Restrições | Estadual</div>
                      {surveyReceived?.SurveyVehicle?.vehicleQuery?.binEstadual
                        ?.restricoes?.existeRestricaoRouboFurto === "0" &&
                      surveyReceived?.SurveyVehicle?.vehicleQuery?.binEstadual
                        ?.restricoes?.veiculoBaixado === "0" &&
                      surveyReceived?.SurveyVehicle?.vehicleQuery?.binEstadual
                        ?.restricoes?.existeRestricaoRenajud === "0" &&
                      surveyReceived?.SurveyVehicle?.vehicleQuery?.binEstadual
                        ?.restricoes?.existeRestricaoGeral === "0" ? (
                        <div className="flex gap-2 items-center font-semibold mt-3">
                          <IoMdCheckmarkCircleOutline color="green" />
                          <div>Não constam restrições</div>
                        </div>
                      ) : (
                        <div className="flex flex-col gap-2 mt-3">
                          {surveyReceived?.SurveyVehicle?.vehicleQuery
                            ?.binEstadual?.restricoes
                            ?.existeRestricaoRouboFurto === "1" && (
                            <div className="flex gap-2 items-center font-semibold">
                              <MdBlock color="red" />
                              <div>Restrição: Roubo e furto</div>
                            </div>
                          )}

                          {surveyReceived?.SurveyVehicle?.vehicleQuery
                            ?.binEstadual?.restricoes
                            ?.existeRestricaoRenajud === "1" && (
                            <div className="flex gap-2 items-center font-semibold">
                              <MdBlock color="red" />
                              <div>Restrição: renajud</div>
                            </div>
                          )}

                          {surveyReceived?.SurveyVehicle?.vehicleQuery
                            ?.binEstadual?.restricoes?.existeRestricaoGeral ===
                            "1" && (
                            <div className="flex gap-2 items-center font-semibold">
                              <MdBlock color="red" />
                              <div>Restrição: Geral</div>
                            </div>
                          )}

                          {surveyReceived?.SurveyVehicle?.vehicleQuery
                            ?.binEstadual?.restricoes?.veiculoBaixado ===
                            "1" && (
                            <div className="flex gap-2 items-center font-semibold">
                              <MdBlock color="red" />
                              <div>Restrição: Veículo Baixado</div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <div>
                      <div className="title-vehicle">
                        Multas e débitos | Estadual
                      </div>
                      <div className="flex gap-2 items-center font-semibold mt-3">
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.restricoes?.dpvat?.existePendencia ==
                        "1" ? (
                          <MdBlock color="red" />
                        ) : (
                          <IoMdCheckmarkCircleOutline color="green" />
                        )}

                        <div>Débitos: dpvat</div>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.restricoes?.dpvat?.existePendencia ==
                          "1" && (
                          <div>
                            | R${" "}
                            {
                              surveyReceived?.SurveyVehicle?.vehicleQuery
                                ?.binEstadual?.restricoes?.dpvat?.valorPendencia
                            }
                          </div>
                        )}
                      </div>
                      <div className="flex gap-2 items-center font-semibold mt-3">
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.restricoes?.ipva?.existePendencia ==
                        "1" ? (
                          <MdBlock color="red" />
                        ) : (
                          <IoMdCheckmarkCircleOutline color="green" />
                        )}
                        <div>Débitos: ipva</div>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.restricoes?.ipva?.existePendencia ==
                          "1" && (
                          <div>
                            | R${" "}
                            {
                              surveyReceived?.SurveyVehicle?.vehicleQuery
                                ?.binEstadual?.restricoes?.ipva?.valorPendencia
                            }
                          </div>
                        )}
                      </div>
                      <div className="flex gap-2 items-center font-semibold mt-3">
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.restricoes?.licenciamento
                          ?.existePendencia == "1" ? (
                          <MdBlock color="red" />
                        ) : (
                          <IoMdCheckmarkCircleOutline color="green" />
                        )}
                        <div>Débitos: licenciamento</div>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.restricoes?.licenciamento
                          ?.existePendencia == "1" && (
                          <div>
                            | R${" "}
                            {
                              surveyReceived?.SurveyVehicle?.vehicleQuery
                                ?.binEstadual?.restricoes?.licenciamento
                                ?.valorPendencia
                            }
                          </div>
                        )}
                      </div>
                      <div className="flex gap-2 items-center font-semibold mt-3">
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.restricoes?.multas?.existePendencia ==
                        "1" ? (
                          <MdBlock color="red" />
                        ) : (
                          <IoMdCheckmarkCircleOutline color="green" />
                        )}
                        <div>Débitos: multas</div>
                        {surveyReceived?.SurveyVehicle?.vehicleQuery
                          ?.binEstadual?.restricoes?.multas?.existePendencia ==
                          "1" && (
                          <div>
                            | R${" "}
                            {
                              surveyReceived?.SurveyVehicle?.vehicleQuery
                                ?.binEstadual?.restricoes?.multas
                                ?.valorPendencia
                            }
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </SurveySheet>

          <SurveySheet survey={surveyReceived}>
            <div className="px-5 mt-10">
              {surveyReceived?.SurveyVehicle?.vehicleQuery?.leilaoConjugado ? (
                <div>
                  <TitleStripe>Dados de Leilões Realizados</TitleStripe>

                  {surveyReceived?.SurveyVehicle?.vehicleQuery?.leilaoConjugado
                    ?.statusRetorno == "1" ? (
                    <>
                      {" "}
                      {surveyReceived?.SurveyVehicle?.vehicleQuery
                        ?.leilaoConjugado?.ocorrencias?.length === 0 ? (
                        <NoOcurrence />
                      ) : (
                        <>
                          {surveyReceived?.SurveyVehicle?.vehicleQuery?.leilaoConjugado?.ocorrencias?.map(
                            (leilaoCompleto, indexL) => (
                              <div key={indexL}>
                                {leilaoCompleto?.ocorrencias?.length > 0 ? (
                                  <>
                                    <div className="overflow-hidden rounded-lg border border-gray-300 mt-3">
                                      <Table striped className="w-full text-xs">
                                        <Table.Head>
                                          <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                            Leiloeiro
                                          </Table.HeadCell>
                                          <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                            Data
                                          </Table.HeadCell>
                                          <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                            Lote
                                          </Table.HeadCell>
                                          <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                            Pátio
                                          </Table.HeadCell>
                                          <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                            Situação chassi
                                          </Table.HeadCell>
                                          <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                            Condição Geral
                                          </Table.HeadCell>
                                          <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                            Comitente
                                          </Table.HeadCell>
                                        </Table.Head>
                                        <Table.Body className="divide-y">
                                          {leilaoCompleto?.ocorrencias?.map(
                                            (leilao, index) => (
                                              <Table.Row
                                                key={index}
                                                className="bg-white dark:border-gray-700 dark:bg-gray-800"
                                              >
                                                <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                                  {leilao?.leiloeiro || "-"}
                                                </Table.Cell>
                                                <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                                  {leilao?.dataLeilao || "-"}
                                                </Table.Cell>
                                                <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                                  {leilao?.lote || "-"}
                                                </Table.Cell>
                                                <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                                  {leilao?.patio || "-"}
                                                </Table.Cell>
                                                <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                                  {leilao?.situacaoChassi ||
                                                    "-"}
                                                </Table.Cell>
                                                <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                                  {leilao?.condicaoGeralVeiculo ||
                                                    "-"}
                                                </Table.Cell>
                                                <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                                  {leilao?.comitente || "-"}
                                                </Table.Cell>
                                              </Table.Row>
                                            )
                                          )}
                                        </Table.Body>
                                      </Table>
                                    </div>

                                    <div className="title-vehicle mt-5">
                                      Score
                                    </div>

                                    <img
                                      className="mx-auto my-4 max-h-32"
                                      src={getImageScoreSale(
                                        leilaoCompleto?.score?.pontuacao
                                      )}
                                    />
                                    {leilaoCompleto?.score?.aceitacao && (
                                      <>
                                        {" "}
                                        <div className="title-vehicle mt-5">
                                          Aceitação de Seguro
                                        </div>
                                        {/* <div className="mt-2 text-sm bg-gray-100 rounded p-2 italic">
                                  Com base em estudo estatístico, a
                                  régua aponta a probabilidade de 0%
                                  a 100% do veículo ser segurado nas
                                  principais seguradoras do país.
                                </div> */}
                                        <div className="square">
                                          <FaCar
                                            fontSize={28}
                                            style={{
                                              left: `${
                                                leilaoCompleto?.score
                                                  ?.aceitacao === "100"
                                                  ? +leilaoCompleto?.score
                                                      ?.aceitacao - 4
                                                  : leilaoCompleto?.score
                                                      ?.aceitacao
                                              }%`,
                                            }}
                                          />
                                        </div>
                                        <div className="font-bold flex justify-end -mt-4">
                                          {leilaoCompleto?.score?.aceitacao}%
                                        </div>
                                      </>
                                    )}

                                    {leilaoCompleto?.score
                                      ?.percentualSobreTabelaReferencia && (
                                      <>
                                        {" "}
                                        <div className="title-vehicle mt-5">
                                          Percentual sobre a Tabela de
                                          Referência
                                        </div>
                                        {/* <div className="mt-2 text-sm bg-gray-100 rounded p-2 italic">
                                  Com base em estudo estatístico, a
                                  régua aponta o possível percentual
                                  da tabela de referência (fipe)
                                  utilizada pela seguradora no
                                  momento da contratação do seguro
                                  do bem.
                                </div> */}
                                        <div className="square">
                                          <FaCar
                                            fontSize={28}
                                            style={{
                                              left: `${
                                                leilaoCompleto?.score
                                                  ?.percentualSobreTabelaReferencia ===
                                                "100"
                                                  ? +leilaoCompleto?.score
                                                      ?.percentualSobreTabelaReferencia -
                                                    4
                                                  : leilaoCompleto?.score
                                                      ?.percentualSobreTabelaReferencia
                                              }%`,
                                            }}
                                          />
                                        </div>
                                        <div className="font-bold flex justify-end -mt-4">
                                          {
                                            leilaoCompleto?.score
                                              ?.percentualSobreTabelaReferencia
                                          }
                                          %
                                        </div>
                                      </>
                                    )}

                                    {leilaoCompleto?.score
                                      ?.exigeVistoriaEspecial && (
                                      <>
                                        <div className="title-vehicle mt-5">
                                          Necessidade de Vistoria Especial
                                        </div>
                                        {/* <div className="mt-2 text-sm bg-gray-100 rounded p-2 italic">
                                  Com base em estudo estatístico, a
                                  régua aponta a menor ou maior
                                  probabilidade de exigência de
                                  vistoria especial por parte da
                                  seguradora.
                                </div> */}
                                        <div className="square">
                                          <FaCar
                                            fontSize={28}
                                            style={{
                                              left: `${leilaoCompleto?.score?.percentualSobreTabelaReferencia}%`,
                                            }}
                                          />
                                        </div>
                                        <div className="font-bold flex justify-end -mt-4">
                                          {
                                            leilaoCompleto?.score
                                              ?.exigeVistoriaEspecial
                                          }
                                        </div>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <NoOcurrence />
                                )}
                              </div>
                            )
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <Alert withBorderAccent color="gray" className="mt-4">
                      Consulta Indisponível no momento
                    </Alert>
                  )}
                </div>
              ) : (
                <>
                  <TitleStripe>Dados de leilões realizados</TitleStripe>
                  <Alert withBorderAccent color="gray" className="mt-4">
                    Informações de leilão indisponível no momento
                  </Alert>
                </>
              )}
            </div>
          </SurveySheet>

          <SurveySheet survey={surveyReceived}>
            <div className="px-5 mt-10">
              {surveyReceived?.SurveyVehicle?.vehicleQuery?.leilaoBase1 && (
                <div>
                  <TitleStripe>Leilão Base I</TitleStripe>

                  {surveyReceived?.SurveyVehicle?.vehicleQuery?.leilaoBase1
                    ?.statusRetorno == "1" ? (
                    <>
                      {" "}
                      {surveyReceived?.SurveyVehicle?.vehicleQuery?.leilaoBase1
                        ?.ocorrencias?.length === 0 ? (
                        <NoOcurrence />
                      ) : (
                        <>
                          {surveyReceived?.SurveyVehicle?.vehicleQuery?.leilaoBase1?.ocorrencias?.map(
                            (leilaoCompleto, indexL) => (
                              <div key={indexL}>
                                <div className="title-vehicle mt-3">
                                  Dados do leilão | {leilaoCompleto?.nomeBase}
                                </div>

                                {leilaoCompleto?.ocorrencias?.length > 0 ? (
                                  <>
                                    <div className="overflow-hidden rounded-lg border border-gray-300 mt-3">
                                      <Table striped className="w-full text-xs">
                                        <Table.Head>
                                          <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                            Leiloeiro
                                          </Table.HeadCell>
                                          <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                            Comitente
                                          </Table.HeadCell>
                                          <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                            Data
                                          </Table.HeadCell>
                                          <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                            Lote
                                          </Table.HeadCell>
                                          <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                            Pátio
                                          </Table.HeadCell>
                                          <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                            Condição Geral
                                          </Table.HeadCell>
                                          <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                            Comitente
                                          </Table.HeadCell>
                                        </Table.Head>
                                        <Table.Body className="divide-y">
                                          {leilaoCompleto?.ocorrencias?.map(
                                            (leilao, index) => (
                                              <Table.Row
                                                key={index}
                                                className="bg-white dark:border-gray-700 dark:bg-gray-800"
                                              >
                                                <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                                  {leilao?.leiloeiro || "-"}
                                                </Table.Cell>
                                                <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                                  {leilao?.comitente || "-"}
                                                </Table.Cell>
                                                <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                                  {leilao?.dataLeilao || "-"}
                                                </Table.Cell>
                                                <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                                  {leilao?.lote || "-"}
                                                </Table.Cell>
                                                <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                                  {leilao?.patio || "-"}
                                                </Table.Cell>
                                                <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                                  {leilao?.condicaoGeralVeiculo ||
                                                    "-"}
                                                </Table.Cell>
                                                <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                                  {leilao?.comitente || "-"}
                                                </Table.Cell>
                                              </Table.Row>
                                            )
                                          )}
                                        </Table.Body>
                                      </Table>
                                    </div>

                                    <div className="title-vehicle mt-5">
                                      Score
                                    </div>

                                    <img
                                      className="mx-auto my-4 max-h-40"
                                      src={getImageScoreSale(
                                        leilaoCompleto?.score?.pontuacao
                                      )}
                                    />
                                    {leilaoCompleto?.score?.aceitacao && (
                                      <>
                                        {" "}
                                        <div className="title-vehicle mt-5">
                                          Aceitação de Seguro
                                        </div>
                                        <div className="mt-2 text-sm bg-gray-100 rounded p-2 italic">
                                          Com base em estudo estatístico, a
                                          régua aponta a probabilidade de 0% a
                                          100% do veículo ser segurado nas
                                          principais seguradoras do país.
                                        </div>
                                        <div className="square">
                                          <FaCar
                                            fontSize={28}
                                            style={{
                                              left: `${
                                                leilaoCompleto?.score
                                                  ?.aceitacao === "100"
                                                  ? +leilaoCompleto?.score
                                                      ?.aceitacao - 4
                                                  : leilaoCompleto?.score
                                                      ?.aceitacao
                                              }%`,
                                            }}
                                          />
                                        </div>
                                        <div className="font-bold flex justify-end -mt-4">
                                          {leilaoCompleto?.score?.aceitacao}%
                                        </div>
                                      </>
                                    )}

                                    {leilaoCompleto?.score
                                      ?.percentualSobreTabelaReferencia && (
                                      <>
                                        {" "}
                                        <div className="title-vehicle mt-5">
                                          Percentual sobre a Tabela de
                                          Referência
                                        </div>
                                        <div className="mt-2 text-sm bg-gray-100 rounded p-2 italic">
                                          Com base em estudo estatístico, a
                                          régua aponta o possível percentual da
                                          tabela de referência (fipe) utilizada
                                          pela seguradora no momento da
                                          contratação do seguro do bem.
                                        </div>
                                        <div className="square">
                                          <FaCar
                                            fontSize={28}
                                            style={{
                                              left: `${
                                                leilaoCompleto?.score
                                                  ?.percentualSobreTabelaReferencia ===
                                                "100"
                                                  ? +leilaoCompleto?.score
                                                      ?.percentualSobreTabelaReferencia -
                                                    4
                                                  : leilaoCompleto?.score
                                                      ?.percentualSobreTabelaReferencia
                                              }%`,
                                            }}
                                          />
                                        </div>
                                        <div className="font-bold flex justify-end -mt-4">
                                          {
                                            leilaoCompleto?.score
                                              ?.percentualSobreTabelaReferencia
                                          }
                                          %
                                        </div>
                                      </>
                                    )}

                                    {leilaoCompleto?.score
                                      ?.exigeVistoriaEspecial && (
                                      <>
                                        <div className="title-vehicle mt-5">
                                          Necessidade de Vistoria Especial
                                        </div>
                                        <div className="mt-2 text-sm bg-gray-100 rounded p-2 italic">
                                          Com base em estudo estatístico, a
                                          régua aponta a menor ou maior
                                          probabilidade de exigência de vistoria
                                          especial por parte da seguradora.
                                        </div>
                                        <div className="square">
                                          <FaCar
                                            fontSize={28}
                                            style={{
                                              left: `${leilaoCompleto?.score?.percentualSobreTabelaReferencia}%`,
                                            }}
                                          />
                                        </div>
                                        <div className="font-bold flex justify-end -mt-4">
                                          {
                                            leilaoCompleto?.score
                                              ?.exigeVistoriaEspecial
                                          }
                                        </div>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <NoOcurrence />
                                )}
                              </div>
                            )
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <Alert withBorderAccent color="gray" className="mt-4">
                      Consulta Indisponível no momento
                    </Alert>
                  )}
                </div>
              )}

              {surveyReceived?.SurveyVehicle?.vehicleQuery?.leilaoSimples && (
                <div>
                  <TitleStripe>Leilão Simples</TitleStripe>

                  {surveyReceived?.SurveyVehicle?.vehicleQuery?.leilaoSimples
                    ?.statusRetorno == "1" ? (
                    <>
                      {surveyReceived?.SurveyVehicle?.vehicleQuery
                        ?.leilaoSimples?.ocorrencias?.length === 0 ? (
                        <NoOcurrence />
                      ) : (
                        <>
                          {surveyReceived?.SurveyVehicle?.vehicleQuery?.leilaoSimples?.ocorrencias?.map(
                            (leilaoCompleto, indexL) => (
                              <div key={indexL}>
                                <div className="title-vehicle mt-3">
                                  Dados do leilão Simples
                                </div>

                                {leilaoCompleto?.ocorrencias?.length > 0 ? (
                                  <>
                                    <div className="overflow-hidden rounded-lg border border-gray-300 mt-3">
                                      <Table striped className="w-full text-xs">
                                        <Table.Head>
                                          <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                            Leiloeiro
                                          </Table.HeadCell>
                                          <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                            Data
                                          </Table.HeadCell>
                                          <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                            Lote
                                          </Table.HeadCell>
                                          <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                            Pátio
                                          </Table.HeadCell>
                                          <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                            Situação chassi
                                          </Table.HeadCell>
                                          <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                            Condição Geral
                                          </Table.HeadCell>
                                          <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                            Comitente
                                          </Table.HeadCell>
                                        </Table.Head>
                                        <Table.Body className="divide-y">
                                          {leilaoCompleto?.ocorrencias?.map(
                                            (leilao, index) => (
                                              <Table.Row
                                                key={index}
                                                className="bg-white dark:border-gray-700 dark:bg-gray-800"
                                              >
                                                <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                                  {leilao?.leiloeiro || "-"}
                                                </Table.Cell>
                                                <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                                  {leilao?.dataLeilao || "-"}
                                                </Table.Cell>
                                                <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                                  {leilao?.lote || "-"}
                                                </Table.Cell>
                                                <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                                  {leilao?.patio || "-"}
                                                </Table.Cell>
                                                <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                                  {leilao?.situacaoChassi ||
                                                    "-"}
                                                </Table.Cell>
                                                <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                                  {leilao?.condicaoGeralVeiculo ||
                                                    "-"}
                                                </Table.Cell>
                                                <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                                  {leilao?.comitente || "-"}
                                                </Table.Cell>
                                              </Table.Row>
                                            )
                                          )}
                                        </Table.Body>
                                      </Table>
                                    </div>

                                    {leilaoCompleto?.score
                                      ?.descricaoPontuacao && (
                                      <>
                                        <div className="title-vehicle mt-5">
                                          Descrição da pontuação
                                        </div>
                                        <div className="mt-2 font-semibold">
                                          {
                                            leilaoCompleto?.score
                                              ?.descricaoPontuacao
                                          }
                                        </div>
                                      </>
                                    )}

                                    {leilaoCompleto?.score?.aceitacao && (
                                      <>
                                        {" "}
                                        <div className="title-vehicle mt-5">
                                          Aceitação de Seguro
                                        </div>
                                        <div className="mt-2 text-sm bg-gray-100 rounded p-2 italic">
                                          Com base em estudo estatístico, a
                                          régua aponta a probabilidade de 0% a
                                          100% do veículo ser segurado nas
                                          principais seguradoras do país.
                                        </div>
                                        <div className="square">
                                          <FaCar
                                            fontSize={28}
                                            style={{
                                              left: `${
                                                leilaoCompleto?.score
                                                  ?.aceitacao === "100"
                                                  ? +leilaoCompleto?.score
                                                      ?.aceitacao - 4
                                                  : leilaoCompleto?.score
                                                      ?.aceitacao
                                              }%`,
                                            }}
                                          />
                                        </div>
                                        <div className="font-bold flex justify-end -mt-4">
                                          {leilaoCompleto?.score?.aceitacao}%
                                        </div>
                                      </>
                                    )}

                                    {leilaoCompleto?.score
                                      ?.percentualSobreTabelaReferencia && (
                                      <>
                                        {" "}
                                        <div className="title-vehicle mt-5">
                                          Percentual sobre a Tabela de
                                          Referência
                                        </div>
                                        <div className="mt-2 text-sm bg-gray-100 rounded p-2 italic">
                                          Com base em estudo estatístico, a
                                          régua aponta o possível percentual da
                                          tabela de referência (fipe) utilizada
                                          pela seguradora no momento da
                                          contratação do seguro do bem.
                                        </div>
                                        <div className="square">
                                          <FaCar
                                            fontSize={28}
                                            style={{
                                              left: `${
                                                leilaoCompleto?.score
                                                  ?.percentualSobreTabelaReferencia ===
                                                "100"
                                                  ? +leilaoCompleto?.score
                                                      ?.percentualSobreTabelaReferencia -
                                                    4
                                                  : leilaoCompleto?.score
                                                      ?.percentualSobreTabelaReferencia
                                              }%`,
                                            }}
                                          />
                                        </div>
                                        <div className="font-bold flex justify-end -mt-4">
                                          {
                                            leilaoCompleto?.score
                                              ?.percentualSobreTabelaReferencia
                                          }
                                          %
                                        </div>
                                      </>
                                    )}

                                    {leilaoCompleto?.score
                                      ?.exigeVistoriaEspecial && (
                                      <>
                                        <div className="title-vehicle mt-5">
                                          Necessidade de Vistoria Especial
                                        </div>
                                        <div className="mt-2 text-sm bg-gray-100 rounded p-2 italic">
                                          Com base em estudo estatístico, a
                                          régua aponta a menor ou maior
                                          probabilidade de exigência de vistoria
                                          especial por parte da seguradora.
                                        </div>
                                        <div className="square">
                                          <FaCar
                                            fontSize={28}
                                            style={{
                                              left: `${leilaoCompleto?.score?.percentualSobreTabelaReferencia}%`,
                                            }}
                                          />
                                        </div>
                                        <div className="font-bold flex justify-end -mt-4">
                                          {
                                            leilaoCompleto?.score
                                              ?.exigeVistoriaEspecial
                                          }
                                        </div>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <NoOcurrence />
                                )}
                              </div>
                            )
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <Alert withBorderAccent color="gray" className="mt-4">
                      Consulta Indisponível no momento
                    </Alert>
                  )}
                </div>
              )}

              {surveyReceived?.SurveyVehicle?.vehicleQuery
                ?.historicoRouboEFurto ? (
                <div>
                  <TitleStripe>Histórico de roubo e furto</TitleStripe>
                  {surveyReceived?.SurveyVehicle?.vehicleQuery
                    ?.historicoRouboEFurto?.statusRetorno == 1 ? (
                    <>
                      {" "}
                      {surveyReceived?.SurveyVehicle?.vehicleQuery
                        ?.historicoRouboEFurto?.temHistoricoRouboEFurto == 0 ? (
                        <NoOcurrence />
                      ) : (
                        <div>
                          {surveyReceived?.SurveyVehicle?.vehicleQuery?.historicoRouboEFurto?.ocorrencias?.map(
                            (historico, index) => (
                              <div key={index} className="bg-red-100 p-2 mt-3">
                                <div className="font-semibold">
                                  {historico.tipoOcorrencia || "Não informado"}
                                </div>
                                <div className="grid grid-cols-2 text-sm gap-1 mt-2">
                                  <div className="flex items-center gap-2">
                                    <div className="font-semibold">
                                      Ano boletim:
                                    </div>
                                    <div>
                                      {historico.anoBoletim || "Não informado"}
                                    </div>
                                  </div>
                                  <div className="flex items-center gap-2">
                                    <div className="font-semibold">
                                      Data ocorrência:
                                    </div>
                                    <div>
                                      {historico.dataOcorrencia ||
                                        "Não informado"}
                                    </div>
                                  </div>
                                  <div className="flex items-center gap-2">
                                    <div className="font-semibold">
                                      Código órgão de segurança:
                                    </div>
                                    <div>
                                      {historico.codigoOrgaoSeguranca ||
                                        "Não informado"}
                                    </div>
                                  </div>
                                  <div className="flex items-center gap-2">
                                    <div className="font-semibold">
                                      Nº boletim:
                                    </div>
                                    <div>
                                      {historico.numeroBoletim ||
                                        "Não informado"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      )}
                    </>
                  ) : (
                    <Alert withBorderAccent color="gray" className="mt-4">
                      Consulta Indisponível no momento
                    </Alert>
                  )}
                </div>
              ) : (
                <>
                  <TitleStripe>Histórico de roubo e furto</TitleStripe>
                  <Alert withBorderAccent color="gray" className="mt-4">
                    Informações de leilão indisponível no momento
                  </Alert>
                </>
              )}

              {surveyReceived?.SurveyVehicle?.vehicleQuery?.recall && (
                <div>
                  <TitleStripe>Recall</TitleStripe>

                  {surveyReceived?.SurveyVehicle?.vehicleQuery?.recall
                    ?.statusRetorno == "1" ? (
                    <>
                      {surveyReceived?.SurveyVehicle?.vehicleQuery?.recall
                        ?.ocorrencias?.length === 0 ? (
                        <NoOcurrence />
                      ) : (
                        <>
                          <div className="overflow-hidden rounded-lg border border-gray-300 mt-3">
                            <Table striped className="w-full text-xs">
                              <Table.Head>
                                <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                  Ano Modelo
                                </Table.HeadCell>
                                <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                  Ano Fab.
                                </Table.HeadCell>
                                <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                  Defeito
                                </Table.HeadCell>
                                <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                  Risco
                                </Table.HeadCell>
                                <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                  Data Registro
                                </Table.HeadCell>
                                <Table.HeadCell className="text-center bg-gray-300 px-1 py-1">
                                  Situação
                                </Table.HeadCell>
                              </Table.Head>
                              <Table.Body className="divide-y">
                                {surveyReceived?.SurveyVehicle?.vehicleQuery?.recall?.ocorrencias?.map(
                                  (recall, index) => (
                                    <Table.Row
                                      key={index}
                                      className="bg-white dark:border-gray-700 dark:bg-gray-800"
                                    >
                                      <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                        {recall?.anoModelo || "-"}
                                      </Table.Cell>
                                      <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                        {recall?.anoFabricacao || "-"}
                                      </Table.Cell>
                                      <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                        {recall?.defeito || "-"}
                                      </Table.Cell>
                                      <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                        {recall?.risco || "-"}
                                      </Table.Cell>
                                      <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                        {recall?.dataRegistro || "-"}
                                      </Table.Cell>
                                      <Table.Cell className="font-medium text-gray-900 dark:text-white text-center px-1 py-1">
                                        {recall?.situacao || "-"}
                                      </Table.Cell>
                                    </Table.Row>
                                  )
                                )}
                              </Table.Body>
                            </Table>
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <Alert withBorderAccent color="gray" className="mt-4">
                      Consulta Indisponível no momento
                    </Alert>
                  )}
                </div>
              )}
            </div>
          </SurveySheet>
        </>
      )}
    </>
  );
};

export default SurveyQuery;
